import { Box, styled, Typography } from '@mui/material'
import type { FC } from 'react'

import { COLORS, unit } from '@hcr/pwa/components'

import { SvgLogoHolidayClub } from '../../assets'
import { useHomeQuery } from '../../hooks'
import { createHomeContent } from '../../utils'
import {
  ButtonSignIn,
  ButtonSignUp,
  LayoutNavigation,
  LayoutNavigationError500,
  LayoutNavigationLoading,
} from '../common'

import { BackgroundImage } from './common'

const homeContent = createHomeContent()

export const HomeUnauthenticated: FC = () => {
  const home = useHomeQuery()

  if (home.isError) {
    return <LayoutNavigationError500 showContextMenuButton />
  }

  if (home.isSuccess) {
    return (
      <LayoutNavigation showContextMenuButton>
        <Container>
          <BackgroundImage url={home.data.imageUrl}>
            <Content>
              <Box marginTop={unit(27)} data-testid='front-page-main-page'>
                <SvgLogoHolidayClub />
              </Box>
            </Content>
            <Content>
              <Typography variant='headlineL' textAlign='center' color={COLORS.white}>
                {home.data.title}
              </Typography>
              <Typography variant='titleS' textAlign='center' color={COLORS.white}>
                {home.data.description}
              </Typography>
            </Content>
            <Content>
              <ButtonSignUp variant='contained' color='primary' />
              <ButtonSignIn variant='outlined' color='white' />
            </Content>
          </BackgroundImage>
          <Box position='relative'>{home.data.content.map(homeContent)}</Box>
        </Container>
      </LayoutNavigation>
    )
  }

  return <LayoutNavigationLoading showContextMenuButton />
}

const Container = styled(Box)`
  padding: ${unit(3)} ${unit(3)} ${unit(17)};
`

const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${unit(4)};
  margin: ${unit(8)} 0;
`
